export default "__VITE_ASSET__CBXzRDk0__"